/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                $(function () {
                    if ($('body').hasClass('single-event')) {
                        $('.event.skip-register').click(function (event) {
                            event.preventDefault();
                            Cookies.set('eskcm_live_events-' + $(this).attr('data-id'), '1', {expires: 30});
                            location.reload();
                        });
                    }
                });

                $(function () {
                    $("input#search-datepicker").datepicker();
                    $("input#search-datepicker").datepicker("option", "dateFormat", 'MM d');
                });

                /* Scroll To Top */
                // browser window scroll (in pixels) after which the "back to top" link is shown
                var offset = 100,
                    //duration of the top scrolling animation (in ms)
                    scroll_top_duration = 700,
                    //grab the "back to top" link
                    $back_to_top = $('.to-top');

                //hide or show the "back to top" link
                $(window).scroll(function () {
                    return ($(this).scrollTop() > offset) ? $back_to_top.addClass('to-top-is-visible') : $back_to_top.removeClass('to-top-is-visible to-top-fade-out');
                });

                //smooth scroll to top
                $back_to_top.on('click', function (event) {
                    event.preventDefault();
                    $('body,html').animate({
                            scrollTop: 0,
                        }, scroll_top_duration
                    );
                });

                /* Video Search */
                $('.video-search #keyword-search , .video-search #category-search').on('click', 'button.submit, button.submit', function (event) {
                    var form = $(this).parents('.tab-pane').attr('id');
                    var term = $('#' + form + ' .' + form + '-field').val();
                    var video_type = $('#' + form + ' #video-type').val();

                    $('.video-content').attr('data-type', form);
                    $('.video-content').attr('data-term', term);
                    $('.video-content').attr('data-video-type', video_type);
                    $('.video-archive').addClass('loading');

                    var jqxhr = $.post(
                        eskcm.ajaxurl,
                        {
                            'action': 'video_search',
                            'video_type': video_type,
                            'type': form,
                            'term': term,
                            'page': 1
                        },
                        function (data) {
                            $(".video-content").html(data);
                            $('.video-archive').removeClass('loading');
                        });
                });

                $('.video-content').on('click', '.pagination.ajax a', function (event) {
                    event.preventDefault();

                    var form = $('.video-content').attr('data-type');
                    var term = $('.video-content').attr('data-term');
                    var video_type = $('.video-content').attr('data-video-type');
                    var page = $(this).parent().attr('data-page');
                    $('.video-archive').addClass('loading');

                    var jqxhr = $.post(
                        eskcm.ajaxurl,
                        {
                            'action': 'video_search',
                            'video_type': video_type,
                            'type': form,
                            'term': term,
                            'page': page
                        },
                        function (data) {
                            $(".video-content").html(data);
                            $('.video-archive').removeClass('loading');
                        });
                });

                $(function () {
                    if ($('body').hasClass('single-partner_letter')) {
                        $('body.single-partner_letter .entry-content').readmore({
                            collapsedHeight: 244,
                            moreLink: '<a class="btn btn-primary read-more" href="#">Más &gt;</a>',
                            lessLink: ''
                        });
                    }
                });

                $(function () {
                    if ($('body').hasClass('single-event')) {
                        var remainingTime = parseInt($('div#event-countdown').attr('data-remaining-time')) * 1000;
                        var endTimestamp = parseInt(Date.parse(new Date()) + remainingTime);
                        var endDate = new Date(endTimestamp);
                        var endDateString = (endDate.getMonth() + 1) + "/" + endDate.getDate() + "/" + endDate.getFullYear() + " " + endDate.getHours() + ":" + endDate.getMinutes() + ":" + endDate.getSeconds();

                        $('div#event-countdown').countdown(endDateString, function (event) {
                            var $this = $(this).html(event.strftime('<div class="countdown-wrapper">' +
                                //+ '<div><span class="time">%w</span><span class="text">weeks</span></div>'
                                '<div><span class="time">%d</span><span class="text">days</span></div>' +
                                '<div><span class="time">%H</span><span class="text">hours</span></div>' +
                                '<div><span class="time">%M</span><span class="text">min</span></div>' +
                                '<div><span class="time">%S</span><span class="text">sec</span></div>' +
                                '</div>'));
                        })
                            .on('finish.countdown', function () {
                                location.reload();
                            });
                    }
                });
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
